export default __webpack_public_path__ + "static/media/delete-icon.c49c30e5.png";